import React from 'react';
import { TableSettings } from '../types/table_settings/TableSettings';
import { EntityType } from '../types/comment';

export interface TableSettingsContextProps {
  tableSettings: Map<string, TableSettings<any>>;
  setTableSettings: (tableSettings: Map<string, TableSettings<any>>) => void;
  tableSettingsLoading: boolean;
  getTableSettings: (type: EntityType, companyId: string, parentType?: EntityType) => TableSettings<any>;
}

const defaultContext: TableSettingsContextProps = {
  tableSettings: new Map(),
  setTableSettings: () => {},
  tableSettingsLoading: false,
  getTableSettings: () => {
    throw new Error('TableSettingsContext not initialized');
  },
};

export const TableSettingsContext = React.createContext<TableSettingsContextProps>(defaultContext);
